var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/react-apollo-hooks/~/lodash/_Symbol.js
// module id = 228
// module chunks = 178331994103267 231608221292675